module.exports = __webpack_public_path__ + "produce-fresh-grass-15.jpg?b89f8e6576e793963e9cb2525f90025b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produce-fresh-grass-15.jpg
// module id = 52
// module chunks = 0